import React, { useState, useContext } from "react";
import Form1 from "./form1";
import Form2 from "./form2";
import Form3 from "./form3";
import Form4 from "./form4";
import Form5 from "./form5";
import Form6 from "./form6";
import Form7 from "./form7";

import Formta1 from "./formta1";
import Formta2 from "./formta2";
import Formta3 from "./formta3";
import Formta4 from "./formta4";
import Formta5 from "./formta5";
import Fromta6 from "./formta6";

import { LanguageContext } from "../../context/LanguageContext";
import TopNavbar from "../../components/TopNavbar/TopNavbar";
import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/footer";

function Register() {
  const [step, setStep] = useState(1);
  const { language } = useContext(LanguageContext);

  const [formData, setFormData] = useState({
    registeredBy: "",
    name: "",
    gender: "",
    dobDay: "",
    dobMonth: "",
    dobYear: "",
    birthHour: "",
    birthMinute: "",
    birthAmPm: "",
    birthPlace: "",
    maritalStatus: "",
    mobile: "",
    alternateMobile: "",
  });

  const [formData2, setFormData2] = useState({
    profileCategory: "",
    education: "",
    password: "",
    bloodGroup: "",
    jobDescription: "",
    monthlyIncome: "",
    workPlace: "",
    caste: "",
    kulam: "",
    kuladeivam: "",
    star: "",
    rasi: "",
    laknam: "",
    height: "",
    weight: "",
    colour: "",
    BodyType: "",
    jathagam: "",
  });

  const [formData3, setFormData3] = useState({
    fatherName: "",
    motherName: "",
    fatherJob: "",
    motherJob: "",
    fatherNative: "",
    motherNative: "",
    siblings: "",
    property: "",
    address: "",
    expectation: "",
  });

  const [formData4, setFormData4] = useState({
    // country: "",
    // state: "",
    // district: "",
    livingPlace: "",
    current_living_place:""
  });

  const [formData5, setFormData5] = useState({
    profilePhoto1: "",
    profilePhoto2: "",
    horoscopePhoto: "",
  });

  const [formData6, setFormData6] = useState({
    planet: "",
    Year: "",
    Month: "",
    Day: "",
  });

  const [RasiChart, setRasiChart] = useState({
    r1: "", r2: "", r3: "", r4: "", r5: "", r6: "",
    r7: "", r8: "", r9: "", r10: "", r11: "", r12: ""
  });

  const [AmsamChart, setAmsamChart] = useState({
    a1: "", a2: "", a3: "", a4: "", a5: "", a6: "",
    a7: "", a8: "", a9: "", a10: "", a11: "", a12: ""
  });

  const renderFormStep = () => {
    if (step === 7) {
      return (
        <Form7
          formData={formData6}
          formData2={formData2}
          formData3={formData3}
          formData4={formData4}
          formData5={formData5}
          FirstFormData={formData}
          setFormData={setFormData6}
          RasiChart={RasiChart}
          setRasiChart={setRasiChart}
          AmsamChart={AmsamChart}
          setAmsamChart={setAmsamChart}
          step={step}
          setStep={setStep}
        />
      );
    }

    if (language === "ta") {
      if (step === 1) return <Formta1 formData={formData} setFormData={setFormData} step={step} setStep={setStep} />;
      if (step === 2) return <Formta2 formData={formData2} setFormData={setFormData2} step={step} setStep={setStep} />;
      if (step === 3) return <Formta3 formData={formData3} setFormData={setFormData3} step={step} setStep={setStep} />;
      if (step === 4) return <Formta4 formData={formData4} setFormData={setFormData4} step={step} setStep={setStep} />;
      if (step === 5) return <Formta5 formData={formData5} setFormData={setFormData5} step={step} setStep={setStep} />;
      if (step === 6) return <Fromta6 formData={formData6} setFormData={setFormData6} step={step} setStep={setStep} />;
    } else {
      if (step === 1) return <Form1 formData={formData} setFormData={setFormData} step={step} setStep={setStep} />;
      if (step === 2) return <Form2 formData={formData2} setFormData={setFormData2} step={step} setStep={setStep} />;
      if (step === 3) return <Form3 formData={formData3} setFormData={setFormData3} step={step} setStep={setStep} />;
      if (step === 4) return <Form4 formData={formData4} setFormData={setFormData4} step={step} setStep={setStep} />;
      if (step === 5) return <Form5 formData={formData5} setFormData={setFormData5} step={step} setStep={setStep} />;
      if (step === 6) return <Form6 formData={formData6} setFormData={setFormData6} step={step} setStep={setStep} />;
    }
    return null;
  };
  return <>
    <TopNavbar />
    <Navbar />
    {renderFormStep()}
    <Footer />
  </>;
}

export default Register;
